export default __webpack_public_path__ + "static/Landmark-Regular-b625829883221f27ccbb93a13cecb1c1.woff2";